import { render, staticRenderFns } from "./delete-employee.vue?vue&type=template&id=20179c28&"
import script from "./delete-employee.vue?vue&type=script&lang=js&"
export * from "./delete-employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports